export const ProspectSignUpPage = async () => {
    await useNamespace(['public_prospects-signup']);
    const {initProspectsSignupJs} = await import("../components/prospects/legacy-scripts/prospects-signup")

    initProspectsSignupJs();
}
